"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDoubleTapEvent = exports.isTapEvent = exports.isSwipeEvent = exports.isRotateEvent = exports.isPressEvent = exports.isPinchEvent = exports.isPanEvent = exports.isUp = exports.isDefault = exports.Recognizer = void 0;
var Recognizer;
(function (Recognizer) {
    Recognizer["Pan"] = "pan";
    Recognizer["Pinch"] = "pinch";
    Recognizer["Press"] = "press";
    Recognizer["Rotate"] = "rotate";
    Recognizer["Swipe"] = "swipe";
    Recognizer["Tap"] = "tap";
    Recognizer["DoubleTap"] = "doubletap";
})(Recognizer = exports.Recognizer || (exports.Recognizer = {}));
;
var Timing;
(function (Timing) {
    Timing["Start"] = "start";
    Timing["Move"] = "move";
    Timing["End"] = "end";
    Timing["Cancel"] = "cancel";
})(Timing || (Timing = {}));
;
var Direction;
(function (Direction) {
    Direction["Left"] = "left";
    Direction["Right"] = "right";
    Direction["Up"] = "up";
    Direction["Down"] = "down";
})(Direction || (Direction = {}));
;
var InOut;
(function (InOut) {
    InOut["In"] = "in";
    InOut["Out"] = "out";
})(InOut || (InOut = {}));
function isDefault(modifier) {
    return modifier === '';
}
exports.isDefault = isDefault;
function isUp(modifier) {
    return modifier === 'up';
}
exports.isUp = isUp;
function isPanEvent(modifier) {
    switch (modifier) {
        case Timing.Start:
        case Timing.Move:
        case Timing.End:
        case Timing.Cancel:
            return true;
        case Direction.Left:
        case Direction.Right:
        case Direction.Up:
        case Direction.Down:
            return true;
    }
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isPanEvent = isPanEvent;
function isPinchEvent(modifier) {
    switch (modifier) {
        case Timing.Start:
        case Timing.Move:
        case Timing.End:
        case Timing.Cancel:
            return true;
        case InOut.In:
        case InOut.Out:
            return true;
    }
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isPinchEvent = isPinchEvent;
function isPressEvent(modifier) {
    if (isUp(modifier)) {
        return true;
    }
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isPressEvent = isPressEvent;
function isRotateEvent(modifier) {
    switch (modifier) {
        case Timing.Start:
        case Timing.Move:
        case Timing.End:
        case Timing.Cancel:
            return true;
    }
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isRotateEvent = isRotateEvent;
function isSwipeEvent(modifier) {
    switch (modifier) {
        case Direction.Left:
        case Direction.Right:
        case Direction.Up:
        case Direction.Down:
            return true;
    }
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isSwipeEvent = isSwipeEvent;
function isTapEvent(modifier) {
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isTapEvent = isTapEvent;
function isDoubleTapEvent(modifier) {
    if (isDefault(modifier)) {
        return true;
    }
    return false;
}
exports.isDoubleTapEvent = isDoubleTapEvent;
//# sourceMappingURL=types.js.map